import script from "./recordStoreTest.vue?vue&type=script&lang=js"
export * from "./recordStoreTest.vue?vue&type=script&lang=js"

import "./recordStoreTest.vue?vue&type=style&index=0&id=7e2b3132&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2b3132"]])

export default __exports__